import { ProductsActionType } from "../utils/actions";

export interface Product {
  id: number;
  brand: string;
  name: string;
  price: string;
  image_url: string;
  category: string;
}

interface ProductsState {
  productsLoading: boolean;
  productsError: boolean;
  products: Product[];
  singleProductLoading: boolean;
  singleProductError: boolean;
  singleProduct: Product;
}

interface ProductsAction {
  type: ProductsActionType;
  payload?: Product[];
}

const ProductsReducer = (
  state: ProductsState,
  action: ProductsAction
): ProductsState => {
  switch (action.type) {
    case ProductsActionType.GetProductsBegin:
      return { ...state, productsLoading: true };
    case ProductsActionType.GetProductsSuccess:
      return { ...state, productsLoading: false, products: action.payload! };
    case ProductsActionType.GetProductsError:
      return { ...state, productsLoading: false, productsError: true };
    case ProductsActionType.GetSingleProductBegin:
      return {
        ...state,
        singleProductLoading: true,
        singleProductError: false,
      };
    case ProductsActionType.GetSingleProductSuccess:
      return {
        ...state,
        singleProductLoading: false,
        singleProduct: action.payload![0],
      };
    case ProductsActionType.GetSingleProductError:
      return {
        ...state,
        singleProductLoading: false,
        singleProductError: true,
      };
    default:
      return state;
  }
};

export default ProductsReducer;
